import '../../httpservices/core/ajax.httpservice.core';

class KbMessageHttpService {

    DashboardMessageInit() {
        return $.get('MskKb/Message/KbDashboardMessageInit');
    }

    KbMessageListReload() {
        return $.get('MskKb/Message/KbMessageListReload');
    }

}

export const KbMessageHttpSvc = new KbMessageHttpService();